<template>
  <div v-show="parentContainer.pageCount > 1" class="mctb-carousel-mctbpagination">
    <div class="mctb-carousel-mctbdot-mctbcontainer">
      <div
        v-for="(page, index) in parentContainer.pageCount"
        :key="index"
        class="mctb-carousel-mctbdot"
        :class="{ 'mctb-carousel-dot--active': index === parentContainer.currentPage }"
        :style="`
          margin-top: ${parentContainer.paginationPadding * 2}px;
          padding: ${parentContainer.paginationPadding}px;
        `"
        @click="parentContainer.goToPage(index)"
      >
        <div
          class="mctb-carousel-mctbdot-mctbinner"
          :style="`
            width: ${parentContainer.paginationSize}px;
            height: ${parentContainer.paginationSize}px;
            background: ${index === parentContainer.currentPage ? parentContainer.paginationActiveColor : parentContainer.paginationColor};
          `"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pagination',
  data() {
    return {
      parentContainer: this.$parent,
    };
  },
};
</script>
